// extracted by mini-css-extract-plugin
export default {"root":"UserRolesMenu_root__PSOVE","top":"UserRolesMenu_top__SaRP4","middle":"UserRolesMenu_middle__n40hu","bottom":"UserRolesMenu_bottom__jDME6"};